module.exports = __webpack_public_path__ + "img/logo_white.5ec97e87.png";